import { clsx } from 'clsx'
import { ChevronIcon } from '@itsrever/design-system'
import { useLocation, useNavigate } from 'react-router'

export const BackButton = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleClickBack = () => {
    if (location.state && location.state.previousPathname.includes('items')) {
      navigate(`/returns/items/${location.search}`)
      return
    }

    navigate(`/returns/orders/${location.search}`)
  }

  return (
    <button
      className={clsx(
        'flex aspect-square size-8 items-center justify-center rounded-lg shadow-sm',
        'border border-solid border-[#E1E4EA]',
        'hover:shadow-sm hover:outline hover:outline-1 hover:outline-offset-0 hover:outline-[#E1E4EA]'
      )}
      onClick={handleClickBack}
    >
      <ChevronIcon className="size-5 rotate-90 text-[#525866]" />
    </button>
  )
}
